// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3RwfK","header":"ClearentDisclaimer_header__1rwcb","inner":"ClearentDisclaimer_inner__yry7r"};